export const LoginUrl = "https://platform.hellohealth.com/hhweb/apps/authentication/#loginPortalConnectV2";


